import { bpAccountingRow } from '../../../../../../models/entities/businessPartner/accounting';
import { lookupAccountingState } from './accountingStateCatalog';
import { formatDate, formatMoney } from './format';
import { CostInBaseState } from './useCostInBase';
import { ProfitInBaseState } from './useProfitInBase';

/** Matches all-shipments grid search: trim, min 3 chars, case-insensitive substring on row payload. */
export function filterAccountingRowsBySearch(
    rows: bpAccountingRow[],
    gridFilter: string,
    costInBase: Record<string, CostInBaseState>,
    profitInBase: Record<string, ProfitInBaseState>,
    baseCurrency: string
): bpAccountingRow[] {
    const q = (gridFilter ?? '').trim();
    if (!q || q.length <= 2) return rows;

    const needle = q.toLocaleLowerCase();

    return rows.filter((r) => {
        const pib = profitInBase[r.shipmentId];
        const cib = costInBase[r.shipmentId];
        const stateLabel = lookupAccountingState(r.accountingState)?.name ?? r.accountingState ?? '';

        const payload = {
            ...r,
            shipmentDate: formatDate(r.shipmentDate),
            dueDate: formatDate(r.dueDate),
            agingDays: r.agingDays != null ? String(r.agingDays) : '',
            paid: formatMoney(r.paid, r.currency),
            openBalance: formatMoney(r.openBalance, r.currency),
            profit: formatMoney(r.profit, r.currency),
            accountingStatus: stateLabel,
            totalCostBase:
                cib?.status === 'ok' ? formatMoney(cib.total, baseCurrency) : cib?.status === 'error' ? 'FX error' : '',
            totalProfitBase:
                pib && (pib.status === 'ok' || pib.status === 'partial')
                    ? formatMoney(pib.total, baseCurrency)
                    : pib?.status === 'error'
                      ? 'FX error'
                      : ''
        };

        return JSON.stringify(payload).toLocaleLowerCase().includes(needle);
    });
}
